// extracted by mini-css-extract-plugin
export default {"form":"FormComment_form__S2BVA","textarea":"FormComment_textarea__ON2-B","btn":"FormComment_btn__0VDfo"};